module.exports = __webpack_public_path__ + "img/boho_rio_gift_disco.2b1e0225.svg";